import { shortenTableEntry } from "../utils/formatter";
import { useEffect, useState } from "react";
import Spinner from "./Spinner/Spinner";

const SingleAudiobookInformationNonEditable = ({ audiobook }) => {

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (audiobook) {
      setLoading(false);
    }
  }, [audiobook]);

  return (
    <div
      className="row"
      style={{
        alignItems: "center",
        borderBlockColor: "black",
        overflowWrap: "anywhere",
        padding: "0px 0px",
        fontSize: "1.8vh",
        textAlign: "left"
      }}
    >
      <div className="col-sm-2" style={{}}>{"aaa"}</div>
      <div className="col-sm-2" style={{}}>{"bbb"}</div>
      <div className="col-sm-2" style={{}}>{"ccc"}</div>

    </div>
  );
};

export default SingleAudiobookInformationNonEditable;
